"use client";

import { createContext } from "react";
import type { BootstrapData } from "../types/bootstrap";

export const BootstrapContext = createContext<BootstrapData | null>(null);

/** Context em vez de store: os dados são imutáveis após o boot, nunca re-renderizam. */
export function BootstrapProvider({
    value,
    children,
}: {
    value: BootstrapData;
    children: React.ReactNode;
}) {
    return <BootstrapContext.Provider value={value}>{children}</BootstrapContext.Provider>;
}
